import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material/";
import { useTranslation } from "react-i18next";
import "./MessageBoard.css";
import Menu from "./Menu";
import { collection, query, getDocs, db } from "../../firebase";
import { orderBy } from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import MessageBoardTable from "./MessageBoardTable";

const MessageBoard = () => {
  const { t, i18n } = useTranslation();
  const numOfMessage = 10;
  const [boards, setBoards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    setBoards([]);
    window.scrollTo(0, 0);
    getBoards();
  }, []);

  const getBoards = async () => {
    const q = query(collection(db, "board"), orderBy("created", "desc"));

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      // console.log("doc", doc.id, " => ", doc.data());
      setBoards((old) => old.concat({ ...doc.data(), id: doc.id }));
      //       setReviewsUS((old) => old.concat({ ...doc.data(), id: doc.id }));
    });
  };

  console.log("boards   ", boards);
  console.log(
    (currentPage - 1) * numOfMessage,
    numOfMessage * (currentPage + 1)
  );
  return (
    <Grid container sx={{ py: 6, width: 1, display: "flex" }}>
      <Menu current="message" />
      <Grid md={10} sm={12} xs={12} item>
        <Box sx={{ px: 7 }}>
          <Box sx={{ fontSize: "22px" }}>
            공지사항{" "}
            <span
              style={{ fontSize: "13px", paddingLeft: "10px", fontWeight: 200 }}
            >
              헤즐릿의 모든 뉴스/공지들을 이곳에서 확인해주세요.
            </span>
          </Box>
          <Box sx={{ mt: 4, borderTop: "2px solid gray", pt: 1 }}>
            <MessageBoardTable
              boards={boards.slice(
                (currentPage - 1) * numOfMessage,
                numOfMessage * currentPage
              )}
            />

            <Stack
              spacing={2}
              sx={{
                pt: 5,
              }}
            >
              <Pagination
                count={Math.ceil(boards.length / numOfMessage)}
                variant="outlined"
                color="secondary"
                page={currentPage}
                onChange={handleChange}
                sx={{ marginLeft: "auto", marginRight: "auto" }}
              />
            </Stack>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MessageBoard;
